import React from "react";
import InputMask from "react-input-mask";
import { formatDateToMMDDYYYY } from "../../../../utils/generalHelper";

function Page1({
  errors,
  isAdmin,
  formData,
  setErrors,
  formStatus,
  setFormData,
  setOpenSignModal,
  taxClassification,
}) {
  return (
    <div className="page-container">
      <div
        className="page"
        style={{
          width: "93%",
          height: "1209px",
          margin: "90px auto 0 auto",
          boxShadow: "0 0 2rem 0 rgba(136, 152, 170, 0.5)",
        }}
      >
        <div
          id="pg1Overlay"
          style={{
            WebkitUserSelect: "none",
            backgroundColor: "rgba(0,0,0,0)",
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: "1",
          }}
        />
        {/* <div
              id="pg1"
              style={{
                WebkitUserSelect: "none",
              }}
            >
              <img
                id="pdf1"
                src="data:image/svg+xml,%3Csvg viewBox='0 0 934 1209' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%0A%3Cdefs%3E%0A%3Cstyle%3E%0A.g0%7Bfill:none%3Bstroke:%23000%3Bstroke-width:1.527%3Bstroke-miterlimit:10%3B%7D%0A.g1%7Bfill:none%3Bstroke:%23000%3Bstroke-width:0.763%3Bstroke-miterlimit:10%3B%7D%0A.g2%7Bfill:%23000%3B%7D%0A.g3%7Bfill:none%3Bstroke:%23000%3Bstroke-width:1.145%3Bstroke-miterlimit:10%3B%7D%0A%3C/style%3E%0A%3C/defs%3E%0A%3Cpath d='M187 54.6V85.9m0-.7v16M54.6 128.3H187.8m-.8-27.9v28.7m-.4-.8H748.4m-1.2 0H880.4M748 54.6v74.5' class='g0'/%3E%0A%3Cpath d='M54.6 146.7H880.4M88 146.3V532.1m-.4-330.4H880.4M87.6 238.3H880.4M111.5 287.6h12.3V275.4H111.5v12.2Zm163.5 0h12.2V275.4H275v12.2Zm110 0h12.2V275.4H385v12.2Zm110 0h12.2V275.4H495v12.2Zm99 0h12.2V275.4H594v12.2ZM111.5 307.8h12.2V295.6H111.5v12.2Zm526.1 2.3h44.8M111.5 363.6h12.2V351.4H111.5v12.2Zm136.2 3.1H682.4M87.6 371.2H671.4m-.8 0h22.8M673.1 414h12.3V401.8H673.1V414ZM693 237.9v55.8m0-.8V312m137.1-.3h50.3M693 311.3v37.4m0-.8V367m71.4-.3h116M693 366.3v55.8m-605.4-.4H594.4M87.6 458.3H594.4M87.6 495H594.4m-.8-73.3H880.4M593.6 495H880.4M594 421.3v74.1' class='g1'/%3E%0A%3Cpath d='M55 550h55V531.7H55V550Z' class='g2'/%3E%0A%3Cpath d='M54.6 531.7H880.4' class='g3'/%3E%0A%3Cpath d='M54.6 550H880.4M638 565.3H880V550H638v15.3Zm0 39.7h22V568.3H638V605Zm22 0h22V568.3H660V605Zm22 0h22V568.3H682V605Zm44 0h22V568.3H726V605Zm22 0h22V568.3H748V605Zm44 0h22V568.3H792V605Zm22 0h22V568.3H814V605Zm22 0h22V568.3H836V605Zm22 0h22V568.3H858V605ZM638 638.6H858V623.3H638v15.3Zm0 39.7h22V641.7H638v36.6Zm22 0h22V641.7H660v36.6Zm44 0h22V641.7H704v36.6Zm22 0h22V641.7H726v36.6Zm22 0h22V641.7H748v36.6Zm22 0h22V641.7H770v36.6Zm22 0h22V641.7H792v36.6Zm22 0h22V641.7H814v36.6Zm22 0h22V641.7H836v36.6Z' class='g1'/%3E%0A%3Cpath d='M55 696.7h55V678.3H55v18.4Z' class='g2'/%3E%0A%3Cpath d='M54.6 678.3H880.4' class='g3'/%3E%0A%3Cpath d='M54.6 696.7H880.4M54.6 880h55.8' class='g1'/%3E%0A%3Cpath d='M54.6 916.7h55.8' class='g3'/%3E%0A%3Cpath d='M109.6 880H583.4' class='g1'/%3E%0A%3Cpath d='M109.6 916.7H583.4' class='g3'/%3E%0A%3Cpath d='M110 879.6v37.6M582.6 880H880.4' class='g1'/%3E%0A%3Cpath d='M582.6 916.7H880.4' class='g3'/%3E%0A%3Cpath d='M54.6 1136.7H748.4m-.8 0H880.4' class='g0'/%3E%0A%3C/svg%3E"
                style={{
                  height: "1209px",
                  width: "98%",
                }}
              />
            </div> */}
        <div className="text-container">
          <span
            className="t s0"
            style={{
              bottom: "0px",
              left: "0px",
              letterSpacing: "-0.14px",
            }}
          >
            <span
              className="t s0"
              style={{
                bottom: "1123px",
                left: "55px",
                letterSpacing: "-0.14px",
              }}
            >
              Form{" "}
            </span>
            <span
              className="t s1"
              style={{
                bottom: "1111px",
                left: "86px",
                letterSpacing: "-0.19px",
              }}
            >
              W-9{" "}
            </span>
            <span
              className="t s0"
              style={{
                bottom: "1109px",
                left: "55px",
                letterSpacing: "-0.15px",
              }}
            >
              (Rev. March 2024){" "}
            </span>
            <span
              className="t v0 s0"
              style={{
                bottom: "1093px",
                left: "55px",
                letterSpacing: "-0.14px",
              }}
            >
              Department of the Treasury{" "}
            </span>
            <span
              className="t v0 s0"
              style={{
                bottom: "1080px",
                left: "55px",
                letterSpacing: "-0.14px",
              }}
            >
              Internal Revenue Service{" "}
            </span>
            <span
              className="t s2"
              style={{
                bottom: "1125px",
                left: "365px",
                letterSpacing: "0.18px",
              }}
            >
              Request for Taxpayer{" "}
            </span>
            <span
              className="t s2"
              style={{
                bottom: "1102px",
                left: "281px",
                letterSpacing: "0.17px",
              }}
            >
              Identification Number and Certification{" "}
            </span>
            <span
              className="t s3"
              style={{
                bottom: "1085px",
                left: "263px",
                letterSpacing: "0.1px",
              }}
            >
              Go to{" "}
            </span>
            <span
              className="t s4"
              style={{
                bottom: "1085px",
                left: "298px",
                letterSpacing: "0.12px",
              }}
            >
              www.irs.gov/FormW9{" "}
            </span>
            <span
              className="t s3"
              style={{
                bottom: "1085px",
                left: "427px",
                letterSpacing: "0.1px",
              }}
            >
              for instructions and the latest information.{" "}
            </span>
            <span
              className="t s5"
              style={{
                bottom: "1123px",
                left: "759px",
                letterSpacing: "-0.11px",
              }}
            >
              Give form to the{" "}
            </span>
            <span
              className="t s5"
              style={{
                bottom: "1107px",
                left: "759px",
                letterSpacing: "-0.12px",
              }}
            >
              requester. Do not{" "}
            </span>
            <span
              className="t s5"
              style={{
                bottom: "1090px",
                left: "759px",
                letterSpacing: "-0.12px",
              }}
            >
              send to the IRS.{" "}
            </span>
          </span>
          <hr
            className="t s3"
            style={{
              top: "95px",
              left: "55px",
              width: "87%",
              border: "1px solid",
              letterSpacing: "0.11px",
            }}
          />
          <span
            className="t s3"
            style={{
              bottom: "1062px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Before you begin.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1062px",
              left: "161px",
              letterSpacing: "0.1px",
            }}
          >
            For guidance related to the purpose of Form W-9, see{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "1062px",
              left: "459px",
              letterSpacing: "0.11px",
            }}
          >
            Purpose of Form
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1062px",
              left: "550px",
              letterSpacing: "0.1px",
            }}
          >
            , below.{" "}
          </span>
          <hr
            className="t s3"
            style={{
              top: "115px",
              left: "55px",
              width: "87%",
              border: "1px solid",
              letterSpacing: "0.11px",
            }}
          />
          <span
            className="t m0 s3"
            style={{
              bottom: "832.3px",
              left: "70.8px",
              letterSpacing: "0.09px",
            }}
          >
            Print or type.{" "}
          </span>
          <span
            className="t m0 s6"
            style={{
              bottom: "767px",
              left: "85.4px",
              letterSpacing: "0.13px",
            }}
          >
            See{" "}
          </span>
          <span
            className="t m0 s4"
            style={{
              bottom: "791.4px",
              left: "85.4px",
              letterSpacing: "0.1px",
            }}
          >
            Specific Instructions{" "}
          </span>
          <span
            className="t m0 s6"
            style={{
              bottom: "914.5px",
              left: "85.4px",
              letterSpacing: "0.11px",
            }}
          >
            on page 3.{" "}
          </span>
          <hr
            className="t s3"
            style={{
              top: "500px",
              left: "88px",
              height: "31.8%",
              width: "1px",
              position: "absolute",
              border: "none",
              backgroundColor: "black",
              transform: "rotate(180deg)",
              transformOrigin: "top left",
              letterSpacing: "0.11px",
            }}
          />
          <span
            className="t s8"
            style={{
              bottom: "1045px",
              left: "94px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1045px",
              left: "112px",
              letterSpacing: "-0.13px",
            }}
          >
            Name of entity/individual. An entry is required. (For a sole
            proprietor or disregarded entity, enter the owner’s name on line 1,
            and enter the business/disregarded{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1032px",
              left: "112px",
              letterSpacing: "-0.13px",
            }}
          >
            entity’s name on line 2.){" "}
          </span>
          <span
            className="t s0"
            style={{
              left: "112px",
              width: "80%",
              bottom: "1032px",
              letterSpacing: "-0.13px",
            }}
          >
            <input
              style={{
                top: "23px",
                width: "100%",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              value={formData.name}
              placeholder="Enter Name here"
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({ ...prevData, name: value }));
                if (value.trim()) {
                  setErrors((prev) => ({ ...prev, name: "" }));
                }
              }}
              className={`form-control py-0 h-px-20 ${
                errors.name ? "border border-danger" : ""
              }`}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "990px",
              left: "94px",
            }}
          >
            2{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "990px",
              left: "112px",
              letterSpacing: "-0.14px",
            }}
          >
            Business name/disregarded entity name, if different from above.{" "}
          </span>
          <span
            className="t s0"
            style={{
              left: "112px",
              width: "80%",
              bottom: "996px",
              letterSpacing: "-0.13px",
            }}
          >
            <input
              style={{
                top: "23px",
                width: "100%",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              disabled={isAdmin || formStatus === "preview"}
              placeholder="Enter Business Name here"
              value={formData.business_name}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  business_name: value,
                }));
                if (value.trim()) {
                  setErrors((prev) => ({ ...prev, business_name: "" }));
                }
              }}
              className={`form-control py-0 h-px-20 ${
                errors.business_name ? "border border-danger" : ""
              }`}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "954px",
              left: "94px",
              letterSpacing: "-0.17px",
            }}
          >
            3a{" "}
          </span>
          <span
            className="t s0 w-100"
            style={{
              bottom: "954px",
              left: "112px",
              letterSpacing: "-0.13px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-32px",
                left: "-24px",
                height: "0px",
                width: "83%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Check the appropriate box for federal tax classification of the
            entity/individual whose name is entered on line 1. Check{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "941px",
              left: "112px",
              letterSpacing: "-0.11px",
            }}
          >
            only{" "}
          </span>
          <span
            className="t s8"
            style={{
              bottom: "941px",
              left: "135px",
              letterSpacing: "-0.18px",
            }}
          >
            one{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "941px",
              left: "157px",
              letterSpacing: "-0.13px",
            }}
          >
            of the following seven boxes.{" "}
          </span>
          <span
            className="t s0 d-center"
            style={{
              bottom: "919px",
              left: "110px",
              letterSpacing: "-0.13px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              disabled={isAdmin || formStatus === "preview"}
              value={formData.federal_tax_classification}
              checked={
                formData.federal_tax_classification ===
                "Individual/sole proprietor"
              }
              onChange={() => taxClassification("Individual/sole proprietor")}
              style={{ height: "14px", width: "14px" }}
            />
            Individual/sole proprietor{" "}
          </span>
          <span
            className="t s0 d-center"
            style={{
              bottom: "919px",
              left: "273px",
              letterSpacing: "-0.14px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              style={{ height: "14px", width: "14px" }}
              disabled={isAdmin || formStatus === "preview"}
              checked={formData.federal_tax_classification === "C corporation"}
              onChange={() => taxClassification("C corporation")}
            />
            C corporation{" "}
          </span>
          <span
            className="t s0 d-center"
            style={{
              bottom: "919px",
              left: "383px",
              letterSpacing: "-0.14px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              style={{ height: "14px", width: "14px" }}
              disabled={isAdmin || formStatus === "preview"}
              checked={formData.federal_tax_classification === "S corporation"}
              onChange={() => taxClassification("S corporation")}
            />
            S corporation{" "}
          </span>
          <span
            className="t s0 d-center"
            style={{
              bottom: "919px",
              left: "493px",
              letterSpacing: "-0.14px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              style={{ height: "14px", width: "14px" }}
              disabled={isAdmin || formStatus === "preview"}
              checked={formData.federal_tax_classification === "Partnership"}
              onChange={() => taxClassification("Partnership")}
            />
            Partnership{" "}
          </span>
          <span
            className="t s0 d-center"
            style={{
              bottom: "919px",
              left: "591px",
              letterSpacing: "-0.14px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              style={{ height: "14px", width: "14px" }}
              disabled={isAdmin || formStatus === "preview"}
              checked={formData.federal_tax_classification === "Trust/estate"}
              onChange={() => taxClassification("Trust/estate")}
            />
            Trust/estate{" "}
            <hr
              className="t s3"
              style={{
                top: "115px",
                left: "98px",
                height: "181px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
          </span>
          <span
            className="t s0 d-center"
            style={{
              bottom: "899px",
              left: "110px",
              letterSpacing: "-0.13px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              style={{ height: "14px", width: "14px" }}
              onChange={() => taxClassification("LLC")}
              disabled={isAdmin || formStatus === "preview"}
              checked={formData.federal_tax_classification === "LLC"}
            />
            LLC. Enter the tax classification (C = C corporation, S = S
            corporation, P = Partnership){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "898px",
              left: "568px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "898px",
              left: "587px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "898px",
              left: "605px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "898px",
              left: "623px",
            }}
          >
            .{" "}
            <input
              style={{
                top: "2px",
                width: "40%",
                fontSize: "11px",
                position: "relative",
                textAlign: "center",
                backgroundColor:
                  formData.federal_tax_classification === "LLC"
                    ? "#f9fafb"
                    : "#e9ecef",
              }}
              type="text"
              maxLength={1}
              value={formData.llc_tax_classification}
              onChange={(e) => {
                const value = e.target.value.toUpperCase();
                setFormData((prevData) => ({
                  ...prevData,
                  llc_tax_classification: value,
                }));
                if (formData.federal_tax_classification === "LLC") {
                  setErrors((prev) => ({
                    ...prev,
                    llc_tax_classification: "",
                  }));
                }
              }}
              disabled={
                isAdmin ||
                formStatus === "preview" ||
                formData.federal_tax_classification !== "LLC"
              }
              className={`form-control py-0 h-px-20 ${
                errors.llc_tax_classification ? "border border-danger" : ""
              }`}
            />
          </span>
          <span
            className="t v1 s8"
            style={{
              bottom: "883px",
              left: "132px",
              letterSpacing: "-0.16px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t v1 s0"
            style={{
              bottom: "883px",
              left: "162px",
              letterSpacing: "-0.13px",
            }}
          >
            Check the “LLC” box above and, in the entry space, enter the
            appropriate code (C, S, or P) for the tax{" "}
          </span>
          <span
            className="t v1 s0"
            style={{
              bottom: "871px",
              left: "132px",
              letterSpacing: "-0.13px",
            }}
          >
            classification of the LLC, unless it is a disregarded entity. A
            disregarded entity should instead check the appropriate{" "}
          </span>
          <span
            className="t v1 s0"
            style={{
              bottom: "859px",
              left: "132px",
              letterSpacing: "-0.13px",
            }}
          >
            box for the tax classification of its owner.{" "}
          </span>
          <span
            className="t s0 d-start w-100"
            style={{
              bottom: "841px",
              left: "110px",
              letterSpacing: "-0.13px",
            }}
          >
            <input
              type="checkbox"
              className="cursor-pointer mr-1"
              checked={formData.federal_tax_classification === "other"}
              style={{ height: "14px", width: "14px" }}
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                const checked = e.target.checked;
                taxClassification("other");
                setFormData((prevData) => ({
                  ...prevData,
                  federal_tax_classification: "other",
                }));
                if (!checked) {
                  setFormData((prev) => ({
                    ...prev,
                    other_federal_tax_classification: "",
                  }));
                }
              }}
            />
            Other (see instructions){" "}
            <input
              style={{
                width: "45%",
                fontSize: "11px",
                position: "relative",
                backgroundColor: formData.other_federal_tax_classification
                  ? "#f9fafb"
                  : "#e9ecef",
              }}
              type="text"
              placeholder="Enter Instructions here"
              value={formData.other_federal_tax_classification}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  federal_tax_classification: "other",
                  other_federal_tax_classification: value,
                }));
                if (formData.other_federal_tax_classification) {
                  setErrors((prev) => ({
                    ...prev,
                    other_federal_tax_classification: "",
                  }));
                }
              }}
              disabled={
                formData.federal_tax_classification !== "other" ||
                formStatus === "preview" ||
                isAdmin
              }
              className={`form-control py-0 h-px-20 ${
                errors.other_federal_tax_classification
                  ? "border border-danger"
                  : ""
              }`}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "817px",
              left: "94px",
              letterSpacing: "-0.18px",
            }}
          >
            3b{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "817px",
              left: "111px",
              letterSpacing: "-0.13px",
            }}
          >
            If on line 3a you checked “Partnership” or “Trust/estate,” or
            checked “LLC” and entered “P” as its tax classification,{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "805px",
              left: "112px",
              letterSpacing: "-0.14px",
              wordSpacing: "1.02px",
            }}
          >
            and you are providing this form to a partnership, trust, or estate
            in which you have an ownership interest, check{" "}
          </span>
          <span
            className="t s0 w-100"
            style={{
              bottom: "792px",
              left: "112px",
              letterSpacing: "-0.13px",
            }}
          >
            this box if you have any foreign partners, owners, or beneficiaries.
            See instructions{" "}
            <hr
              className="t s3"
              style={{
                top: "-12px",
                left: "-24px",
                height: "1%",
                width: "83%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "513px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "532px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "550px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "568px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "587px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "605px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "623px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "792px",
              left: "642px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t s0 d-end"
            style={{
              bottom: "792px",
              left: "660px",
            }}
          >
            .{" "}
            <input
              type="checkbox"
              value={formData.has_foreign_partners}
              className="cursor-pointer ml-1 bg-red"
              checked={formData.has_foreign_partners}
              style={{ height: "14px", width: "14px" }}
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                setFormData((prevData) => ({
                  ...prevData,
                  has_foreign_partners: !prevData.has_foreign_partners,
                }));
              }}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "952px",
              left: "699px",
            }}
          >
            4{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "952px",
              left: "711px",
              letterSpacing: "-0.14px",
            }}
          >
            Exemptions (codes apply only to{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "939px",
              left: "711px",
              letterSpacing: "-0.12px",
            }}
          >
            certain entities, not individuals;{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "926px",
              left: "711px",
              letterSpacing: "-0.13px",
            }}
          >
            see instructions on page 3):{" "}
          </span>
          <span
            className="t v0 s0 d-start"
            style={{
              bottom: "896px",
              left: "696px",
              letterSpacing: "-0.14px",
            }}
          >
            Exempt payee code (if any){" "}
            <input
              style={{
                top: "2px",
                width: "19%",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              maxLength={2}
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  exempt_payee_code: value,
                }));
              }}
              value={formData.exempt_payee_code}
              className="form-control py-0 h-px-20"
            />
          </span>
          <span
            className="t s0"
            style={{
              bottom: "872px",
              left: "699px",
              letterSpacing: "-0.15px",
            }}
          >
            Exemption from Foreign Account Tax{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "859px",
              left: "699px",
              letterSpacing: "-0.14px",
            }}
          >
            Compliance Act (FATCA) reporting{" "}
          </span>
          <span
            className="t s0 d-start"
            style={{
              bottom: "841px",
              left: "700px",
              letterSpacing: "-0.13px",
            }}
          >
            code (if any){" "}
            <input
              style={{
                width: "52%",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              maxLength={3}
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  fatca_code: value,
                }));
              }}
              value={formData.fatca_code}
              className="form-control text-center py-0 h-px-20"
            />
          </span>
          <span
            className="t s9"
            style={{
              bottom: "811px",
              left: "710px",
              letterSpacing: "-0.14px",
            }}
          >
            (Applies to accounts maintained{" "}
          </span>
          <span
            className="t s9"
            style={{
              bottom: "798px",
              left: "723px",
              letterSpacing: "-0.13px",
            }}
          >
            outside the United States.){" "}
          </span>
          <span
            className="t s8"
            style={{
              bottom: "770px",
              left: "94px",
            }}
          >
            5{" "}
          </span>
          <span
            className="t s0"
            style={{
              width: "45%",
              left: "112px",
              bottom: "750px",
              letterSpacing: "-0.13px",
            }}
          >
            Address (number, street, and apt. or suite no.). See instructions.{" "}
            <input
              style={{
                top: "-2px",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              placeholder="Address"
              value={formData.address}
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  address: value,
                }));
                if (value.trim()) {
                  setErrors((prev) => ({ ...prev, address: "" }));
                }
              }}
              className={`form-control py-0 h-px-20 ${
                errors.address ? "border border-danger" : ""
              }`}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "734px",
              left: "94px",
            }}
          >
            6{" "}
          </span>
          <span
            className="t s0"
            style={{
              width: "45%",
              left: "112px",
              bottom: "714px",
              letterSpacing: "-0.14px",
            }}
          >
            City, state, and ZIP code{" "}
            <input
              style={{
                top: "-2px",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              placeholder="City"
              disabled={isAdmin || formStatus === "preview"}
              value={formData.city_state_zip}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  city_state_zip: value,
                }));
                if (value.trim()) {
                  setErrors((prev) => ({ ...prev, city_state_zip: "" }));
                }
              }}
              className={`form-control py-0 h-px-20 ${
                errors.city_state_zip ? "border border-danger" : ""
              }`}
            />
          </span>
          <span
            className="t s0"
            style={{
              width: "29%",
              left: "600px",
              bottom: "718px",
              letterSpacing: "-0.14px",
            }}
          >
            Requester’s name and address (optional){" "}
            <textarea
              style={{
                top: "-2px",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              rows="3"
              cols="5"
              className="form-control py-0"
              placeholder="Requester Name and Address"
              value={formData.requester_name_and_address}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  requester_name_and_address: value,
                }));
              }}
              disabled={isAdmin || formStatus === "preview"}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "697px",
              left: "94px",
            }}
          >
            7{" "}
          </span>
          <span
            className="t s0"
            style={{
              width: "45%",
              left: "112px",
              bottom: "677px",
              letterSpacing: "-0.14px",
            }}
          >
            List account number(s) here (optional){" "}
            <input
              style={{
                top: "-2px",
                fontSize: "11px",
                position: "relative",
                backgroundColor: "#e9ecef",
              }}
              type="text"
              value={formData.account_numbers}
              disabled={isAdmin || formStatus === "preview"}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  account_numbers: value,
                }));
              }}
              placeholder="List Account numbers"
              className="form-control py-0 h-px-20"
            />
          </span>
          <span
            className="t"
            style={{
              left: "52px",
              color: "#fff",
              bottom: "658px",
              fontSize: "12px",
              fontWeight: "900",
              letterSpacing: "0.12px",
              backgroundColor: "#000",
            }}
          >
            Part I{" "}
          </span>
          <span
            className="t sb"
            style={{
              left: "132px",
              width: "100%",
              bottom: "656px",
              letterSpacing: "0.14px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-31px",
                left: "-80px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Taxpayer Identification Number (TIN){" "}
            <hr
              className="t s3"
              style={{
                top: "-12.5px",
                left: "-80px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s6"
            style={{
              bottom: "636px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Enter your TIN in the appropriate box. The TIN provided must match
            the name given on line 1 to avoid{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "622px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            backup withholding. For individuals, this is generally your social
            security number (SSN). However, for a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "607px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            resident alien, sole proprietor, or disregarded entity, see the
            instructions for Part I, later. For other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "592px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            entities, it is your employer identification number (EIN). If you do
            not have a number, see{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "592px",
              left: "539px",
              letterSpacing: "0.1px",
            }}
          >
            How to get a{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "578px",
              left: "55px",
              letterSpacing: "0.12px",
            }}
          >
            TIN
          </span>
          <span
            className="t s6"
            style={{
              bottom: "578px",
              left: "74px",
              letterSpacing: "0.08px",
            }}
          >
            , later.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "553px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "553px",
              left: "90px",
              letterSpacing: "0.1px",
            }}
          >
            If the account is in more than one name, see the instructions for
            line 1. See also{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "553px",
              left: "527px",
              letterSpacing: "0.11px",
            }}
          >
            What Name and{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "538px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Number To Give the Requester{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "538px",
              left: "227px",
              letterSpacing: "0.1px",
            }}
          >
            for guidelines on whose number to enter.{" "}
          </span>
          <span
            className="t s8"
            style={{
              bottom: "603px",
              left: "644px",
              letterSpacing: "-0.15px",
            }}
          >
            Social security number{" "}
            <InputMask
              mask="999-99-9999"
              value={formData.ssn}
              disabled={
                isAdmin ||
                formStatus === "preview" ||
                formData.federal_tax_classification !==
                  "Individual/sole proprietor"
              }
              onChange={(e) => {
                const value = e.target.value;
                const isValidSSN = /^\d{3}-\d{2}-\d{4}$/.test(value);
                const isValidEIN = /^\d{2}-\d{7}$/.test(formData.ein);
                setFormData((prev) => ({ ...prev, ssn: value }));
                if (isValidSSN || isValidEIN) {
                  setErrors((prev) => ({ ...prev, ssn: "", ein: "" }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    ssn: "Invalid SSN",
                  }));
                }
              }}
              className={`form-control ${
                errors.ssn ? "border border-danger" : ""
              }`}
              style={{
                height: "39px",
                left: "-10px",
                width: "240px",
                fontSize: "11px",
                padding: "2px 4px",
                position: "relative",
                letterSpacing: "15px",
                backgroundColor: "#f9fafb",
              }}
              placeholder="___-__-____"
            />
          </span>
          <span
            className="t s5"
            style={{
              bottom: "585px",
              left: "638px",
              letterSpacing: "-0.13px",
            }}
          >
            or{" "}
          </span>
          <span
            className="t s8"
            style={{
              bottom: "530px",
              left: "644px",
              letterSpacing: "-0.15px",
            }}
          >
            Employer identification number{" "}
            <InputMask
              mask="99-9999999"
              value={formData.ein}
              disabled={
                isAdmin ||
                formStatus === "preview" ||
                formData.federal_tax_classification ===
                  "Individual/sole proprietor"
              }
              onChange={(e) => {
                const value = e.target.value;
                const isValidEIN = /^\d{2}-\d{7}$/.test(value);
                const isValidSSN = /^\d{3}-\d{2}-\d{4}$/.test(formData.ssn);
                setFormData((prev) => ({ ...prev, ein: value }));

                if (isValidEIN || isValidSSN) {
                  setErrors((prev) => ({ ...prev, ssn: "", ein: "" }));
                } else if (
                  formData.federal_tax_classification ===
                  "Individual/sole proprietor"
                ) {
                  setFormData((prev) => ({ ...prev, ein: "" }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    ein: "Invalid SSN or EIN",
                  }));
                }
              }}
              className={`form-control ${
                errors.ein ? "border border-danger" : ""
              }`}
              style={{
                height: "39px",
                left: "-10px",
                width: "240px",
                fontSize: "11px",
                padding: "2px 4px",
                position: "relative",
                letterSpacing: "15px",
                backgroundColor: "#f9fafb",
              }}
              placeholder="__-_______"
            />
          </span>
          <span
            className="t"
            style={{
              left: "52px",
              color: "#fff",
              bottom: "512px",
              fontSize: "12px",
              fontWeight: "900",
              letterSpacing: "0.12px",
              backgroundColor: "#000",
            }}
          >
            Part II{" "}
          </span>
          <span
            className="t sb w-100"
            style={{
              bottom: "510px",
              left: "132px",
              letterSpacing: "0.13px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-31px",
                left: "-80px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Certification{" "}
            <hr
              className="t s3"
              style={{
                top: "-12px",
                left: "-80px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s6"
            style={{
              bottom: "492px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            Under penalties of perjury, I certify that:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "474px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            1. The number shown on this form is my correct taxpayer
            identification number (or I am waiting for a number to be issued to
            me); and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "457px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            2. I am not subject to backup withholding because (a) I am exempt
            from backup withholding, or (b) I have not been notified by the
            Internal Revenue{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "442px",
              left: "69px",
              letterSpacing: "0.09px",
            }}
          >
            Service (IRS) that I am subject to backup withholding as a result of
            a failure to report all interest or dividends, or (c) the IRS has
            notified me that I am{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "428px",
              left: "69px",
              letterSpacing: "0.1px",
            }}
          >
            no longer subject to backup withholding; and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "409px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            3. I am a U.S. citizen or other U.S. person (defined below); and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "391px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            4. The FATCA code(s) entered on this form (if any) indicating that I
            am exempt from FATCA reporting is correct.{" "}
          </span>
          <span
            className="t v2 s3"
            style={{
              bottom: "372px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Certification instructions.{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "372px",
              left: "200px",
              letterSpacing: "0.1px",
            }}
          >
            You must cross out item 2 above if you have been notified by the IRS
            that you are currently subject to backup{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "372px",
              left: "778px",
              letterSpacing: "0.1px",
            }}
          >
            withholding{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "357px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            because you have failed to report all interest and dividends on your
            tax return. For real estate transactions, item 2 does not apply.{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "357px",
              left: "736px",
              letterSpacing: "0.1px",
            }}
          >
            For mortgage interest paid,{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "342px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            acquisition or abandonment of secured property, cancellation of
            debt, contributions to an individual retirement{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "342px",
              left: "636px",
              letterSpacing: "0.1px",
            }}
          >
            arrangement (IRA), and, generally, payments{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "328px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            other than interest and dividends, you are not required to sign the
            certification, but you must{" "}
          </span>
          <span
            className="t v2 s6"
            style={{
              bottom: "328px",
              left: "541px",
              letterSpacing: "0.09px",
            }}
          >
            provide your correct TIN. See the instructions for Part II, later.{" "}
          </span>
          <span
            className="t sb w-100"
            style={{
              bottom: "306px",
              left: "55px",
              letterSpacing: "0.12px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-31px",
                left: "-4px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Sign{" "}
            <hr
              className="t s3"
              style={{
                top: "4px",
                left: "-4px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t sb"
            style={{
              bottom: "291px",
              left: "55px",
              letterSpacing: "0.16px",
            }}
          >
            Here{" "}
            <hr
              className="t s3"
              style={{
                top: "-11px",
                left: "44px",
                height: "35px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
          </span>
          <span
            className="t s8"
            style={{
              bottom: "308px",
              left: "116px",
              letterSpacing: "-0.14px",
            }}
          >
            Signature of{" "}
          </span>
          <span
            className="t s8 d-start"
            style={{
              bottom: formData?.signature ? "280px" : "290px",
              left: "116px",
              letterSpacing: "-0.15px",
            }}
          >
            U.S. person{" "}
            {formData.signature ? (
              <>
                <img
                  src={formData?.signature}
                  alt="signature"
                  style={{
                    top: "-9px",
                    height: "45px",
                    width: "100px",
                    marginLeft: "10px",
                    position: "relative",
                  }}
                />
                {isAdmin || formStatus === "preview" ? (
                  ""
                ) : (
                  <button
                    style={{
                      top: "-7px",
                      marginLeft: "7px",
                      position: "relative",
                    }}
                    onClick={() => setOpenSignModal(true)}
                    className="btn btn-default px-2 py-1 text-xxs"
                  >
                    Edit Signature
                  </button>
                )}
              </>
            ) : (
              <button
                style={{
                  top: "-7px",
                  marginLeft: "7px",
                  position: "relative",
                }}
                onClick={() => setOpenSignModal(true)}
                className={`btn btn-default px-2 py-1 text-xxs ${
                  errors?.signature ? "border border-danger" : ""
                }`}
              >
                E-Signature
              </button>
            )}
          </span>
          <span
            className="t s8 d-start text-helvetica-neue-roman"
            style={{
              width: "31%",
              left: "589px",
              bottom: "294px",
              letterSpacing: "-0.17px",
            }}
          >
            Date{" "}
            <span className="text-dark text-sm">
              {formatDateToMMDDYYYY(formData.date)}
            </span>
          </span>
          <span
            className="t sc"
            style={{
              bottom: "252px",
              left: "55px",
              letterSpacing: "0.19px",
            }}
          >
            General Instructions{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "235px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Section references are to the Internal Revenue Code unless otherwise{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "222px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            noted.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "203px",
              left: "55px",
              letterSpacing: "0.12px",
            }}
          >
            Future developments
          </span>
          <span
            className="t s6"
            style={{
              bottom: "203px",
              left: "178px",
              letterSpacing: "0.1px",
            }}
          >
            . For the latest information about developments{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "189px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            related to Form W-9 and its instructions, such as legislation
            enacted{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "176px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            after they were published, go to{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "176px",
              left: "232px",
              letterSpacing: "0.12px",
            }}
          >
            www.irs.gov/FormW9
          </span>
          <span
            className="t s6"
            style={{
              bottom: "176px",
              left: "349px",
            }}
          >
            .{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "146px",
              left: "55px",
              letterSpacing: "0.19px",
            }}
          >
            What’s New{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "128px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Line 3a has been modified to clarify how a disregarded entity
            completes{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "115px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            this line. An LLC that is a disregarded entity should check the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "101px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            appropriate box for the tax classification of its owner. Otherwise,
            it{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "87px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            should check the “LLC” box and enter its appropriate tax
            classification.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "263px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            New line 3b has been added to this form. A flow-through entity is{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "249px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            required to complete this line to indicate that it has direct or
            indirect{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "235px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            foreign partners, owners, or beneficiaries when it provides the Form
            W-9{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "222px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            to another flow-through entity in which it has an ownership
            interest. This{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "208px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            change is intended to provide a flow-through entity with information{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "194px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            regarding the status of its indirect foreign partners, owners, or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "180px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            beneficiaries, so that it can satisfy any applicable reporting{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "167px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            requirements. For example, a partnership that has any indirect
            foreign{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "153px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            partners may be required to complete Schedules K-2 and K-3. See the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "139px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Partnership Instructions for Schedules K-2 and K-3 (Form 1065).{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "109px",
              left: "484px",
              letterSpacing: "0.18px",
            }}
          >
            Purpose of Form{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "92px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            An individual or entity (Form W-9 requester) who is required to file
            an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "78px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            information return with the IRS is giving you this form because they{" "}
          </span>
          <span
            className="t s0 w-100"
            style={{
              bottom: "52px",
              left: "362px",
              letterSpacing: "-0.15px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-36px",
                left: "-310px",
                height: "1%",
                width: "87%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            Cat. No. 10231X{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "52px",
              left: "756px",
              letterSpacing: "-0.14px",
            }}
          >
            Form{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "50px",
              left: "784px",
              letterSpacing: "0.18px",
            }}
          >
            W-9{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "52px",
              left: "816px",
              letterSpacing: "-0.14px",
            }}
          >
            (Rev. 3-2024){" "}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Page1;
